module.exports = __webpack_public_path__ + "img/footer2.74b21993.png";